export default {"src":"/_next/static/media/faq.3e2b3262.svg","height":16,"width":16};